/* MUI */
import { Box, Flex } from '@auviknetworks/iceberg-ui';

/*  React  */
import { CellContext } from '@tanstack/react-table';
import React from 'react';

/**
 * A React component that renders a clickable value in a table cell.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.row - The row object containing the data.
 * @param {React.ComponentType<CellContext<TData, unknown>>} props.component - The component to render.
 * @returns {React.ReactElement} The rendered table cell component.
 */
export const ClickableCell = <TData,>({
    row,
    component: Component,
    ...props
}: CellContext<TData, unknown> & {
    component: React.ComponentType<CellContext<TData, unknown>>;
}): React.ReactElement => {
    const onClick =
        (row.original as { onClick: () => void })?.onClick ?? (() => {});
    return (
        <Flex onClick={onClick}>
            <Box as="a" className="link underline" role="link">
                <Component {...props} row={row} />
            </Box>
        </Flex>
    );
};
